// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"658fe621da989aa6590e","411":"eb53ad62756dda7944c3","562":"0d9899550cb20c9e5fd3","812":"0549bd47de95a11183f8"}[chunkId] + ".chunk.js";
};